export const deleteFilledPercentage = (state) => {
  const next = {...state};
  delete next["filledPercentage"];
  return next;
}
